







import { defineComponent, ref } from '@vue/composition-api'
import ServiceWorkerUpdatePopup from '@/pwa/components/ServiceWorkerUpdatePopup.vue'
import { getAllSelectItemList, getFieldTypeList, getValueTypeList, getOrderTypeList } from '@/api/admin'
import { AdminModule } from './store/modules/admin'
import { AppModule } from './store/modules/app'
import { FieldType, ValueType } from './api/types-app'
import { IOrderTypeData } from './api/types'

export default defineComponent({
  name: 'App',
  components: {
    ServiceWorkerUpdatePopup
  },
  setup() {
    const selectItemListCollection = ref(null)
    const valueTypeCollection = ref<Array<ValueType> | null>(null)
    const fieldTypeCollection = ref<Array<FieldType> | null>(null)
    const orderTypeCollection = ref<Array<IOrderTypeData> | null>(null)

    const getSelectItemListCollection = async() => {
      selectItemListCollection.value = (await getAllSelectItemList()).data
      AppModule.loadSelectItemListCollection(selectItemListCollection.value)
    }

    const getValueTypesCollection = async() => {
      valueTypeCollection.value = (await getValueTypeList()).data
      AppModule.loadValueTypeListCollection(valueTypeCollection.value)
    }

    const getFieldTypesCollection = async() => {
      fieldTypeCollection.value = (await getFieldTypeList()).data
      AppModule.loadFieldTypeListCollection(fieldTypeCollection.value)
    }

    const getOrderTypesCollection = async() => {
      orderTypeCollection.value = (await getOrderTypeList()).data
      AppModule.loadOrderTypeListCollection(orderTypeCollection.value)
    }

    getSelectItemListCollection()
    getValueTypesCollection()
    getFieldTypesCollection()
    getOrderTypesCollection()
  }
})
